import jp from 'jsonpath'
import { AiResult, FormattedSummaryResult, StructuredSummaryResult } from '../../../../../../models/AiResult'
import { FormattedResultContentType } from '../common'
import { getSafeValueOnPath } from '../../utils'
import { getEditorStateFromHtml, getEditorTextContent, parseIntoHeadlessEditor } from '../Lexical/utils'

export const getResultDisplayValues = (result: StructuredSummaryResult, path: string) => {
  const { formattedResults } = result
  const plainTextResult = getSafeValueOnPath(result, path, '')
  const formattedResult = formattedResults[path]
  if (!formattedResult) {
    return {
      plainTextResult,
    }
  }
  const htmlResult = formattedResult.find(({ contentType }) => contentType === FormattedResultContentType.HTML)
  const lexicalResult = formattedResult.find(({ contentType }) => contentType === FormattedResultContentType.LEXICAL)

  return {
    plainTextResult,
    htmlResult: htmlResult?.content,
    lexicalResult: validateLexicalResult(lexicalResult),
  }
}

const validateLexicalResult = (lexicalResult?: FormattedSummaryResult) => {
  if (!lexicalResult) {
    return
  }

  const { content } = lexicalResult
  try {
    parseIntoHeadlessEditor(content)
    return content
  } catch (e) {
    console.warn(`Unable to parse Lexical state: ${content}`)
    console.warn(e)
  }
}

export const replaceResultOnPath = (aiResult: AiResult, basePath: string, path: string, content: string | boolean) => {
  const { result } = aiResult
  const clonedResult = structuredClone(result)
  const baseResult = getSafeValueOnPath(clonedResult, basePath)
  jp.value(baseResult, path, content)
  return clonedResult
}

export const replaceFormattedResultOnPath = (aiResult: AiResult, basePath: string, path: string, contentType: string, content: string) => {
  const { result } = aiResult
  const clonedResult = structuredClone(result)
  const baseResult = getSafeValueOnPath(clonedResult, basePath)
  const { formattedResults } = baseResult
  if (!formattedResults[path]) {
    formattedResults[path] = []
  }
  const hasFormattedResult = formattedResults[path].some((formattedResult: FormattedSummaryResult) => {
    const { contentType: resultContentType } = formattedResult
    return resultContentType === contentType
  })

  if (!getEditorTextContent(getEditorStateFromHtml(content)).trim().length) {
    if (formattedResults[path]) {
      delete formattedResults[path]
    }
  } else if (!hasFormattedResult) {
    formattedResults[path].push({ contentType, content })
  } else {
    formattedResults[path] = formattedResults[path].map((formattedResult: FormattedSummaryResult) => {
      const { contentType: resultContentType } = formattedResult
      if (resultContentType === contentType) {
        return {
          contentType,
          content,
        }
      }
      return formattedResult
    })
  }
  return clonedResult
}
